import {
  Phone,
  Mail,
  MapPin,
  Menu,
  X,
  Sun,
  Moon,
  CircleCheck,
  CarFront,
  Footprints,
  Armchair,
  Fence,
  Layers,
  Lock,
  Blocks,
  TrendingUp,
  User,
  Wrench,
  Building2,
  Hash,
  Calendar,
  Clock,
  ClipboardCheck,
} from 'lucide-react';

const wrap =
  (Icon) =>
  ({ className, size, width, height, ariaHidden = true } = {}) => (
    <Icon
      className={className}
      size={
        size ?? (width ? Number(width) : height ? Number(height) : undefined)
      }
      aria-hidden={ariaHidden}
    />
  );

export const PhoneIcon = wrap(Phone);
export const EmailIcon = wrap(Mail);
export const LocationIcon = wrap(MapPin);
export const HamburgerIcon = wrap(Menu);
export const CloseIcon = wrap(X);
export const SunIcon = wrap(Sun);
export const MoonIcon = wrap(Moon);
export const CheckIcon = wrap(CircleCheck);
export const UserIcon = wrap(User);
export const ServiceIcon = wrap(Wrench);
export const BuildingIcon = wrap(Building2);
export const PostcodeIcon = wrap(Hash);
export const CalendarIcon = wrap(Calendar);
export const ClockIcon = wrap(Clock);
export const QuoteIcon = wrap(ClipboardCheck);

const _ICON_MAP = {
  home: wrap(CarFront),
  path: wrap(Footprints),
  grid: wrap(Armchair),
  fencing: wrap(Fence),
  decking: wrap(Layers),
  gates: wrap(Lock),
  walls: wrap(Blocks),
  stairs: wrap(TrendingUp),
};

export const getIcon = (iconName) => _ICON_MAP[iconName] || null;
